import { getAuth } from "firebase/auth";
import { doc, getDoc, getFirestore, setDoc } from "firebase/firestore";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { router } from "../../Constants";
import app from "../../firebase";
import { showLog } from "../../utils/log";
import ScreenOTP from "./ScreenOTP";

async function saveData(location, navigate, user) {
  showLog("OtpRegister Masuk saveData");
  try {
    let data = location.state.detail;
    let phoneNumber = "+62" + data.phone1.replace(/ /g, "");
    const auth = getAuth(app);
    const db = getFirestore(app);
    const docRef = doc(db, "users", phoneNumber.trim());
    const docSnap = await getDoc(docRef);
    if (!docSnap.data()) {
      const uid = phoneNumber;
      const docData = {
        nama: data.Nama,
        telp: phoneNumber,
        uuid: user.uid,
      };
      const docRef = await setDoc(doc(db, "users", uid), docData, {
        merge: true,
      });
      localStorage.setItem("register-nama", "");
      localStorage.setItem("register-telp", "");
      localStorage.setItem("login", JSON.stringify(docData));
      navigate(`${router}/order`);
    } else {
      if (location.status == "insert") {
        alert(
          "No Telepon ini sudah terdaftar, mohon untuk mengisi no telp yang lain."
        );
      } else {
        const uid = phoneNumber;
        const docData = {
          nama: data.Nama,
          telp: phoneNumber,
          uuid: user.uid,
        };
        const docRef = await setDoc(doc(db, "users", uid), docData, {
          merge: true,
        });
        localStorage.setItem("register-nama", "");
        localStorage.setItem("register-alamat", "");
        localStorage.setItem("register-telp", "");
        localStorage.setItem("login", JSON.stringify(docData));
        navigate(`${router}/order`);
      }
    }
  } catch (e) {
    showLog(`"Error adding document = ${e}`);
  }
}

function KodeOTP() {
  showLog("OtpRegister Masuk KodeOTP");
  let navigate = useNavigate();
  let location = useLocation();
  const { addToast } = useToasts();
  const [loading, setLoading] = React.useState(false);
  const [input, setInput] = React.useState({
    mobile: "",
    otp: "",
  });

  async function onOtp() {
    showLog("OtpRegister Masuk onOtp");
    const code = input.otp;
    if (window.confirmationResult !== undefined) {
      window.confirmationResult
        .confirm(code)
        .then(async (result) => {
          const user = result.user;
          await saveData(location, navigate, user);
          setLoading(false);
          // ...
        })
        .catch((error) => {
          switch (error.code) {
            case "auth/too-many-requests":
              setLoading(false);
              addToast("Too many requests, please try again after 5 minutes.", {
                appearance: "error",
                autoDismiss: true,
              });
              break;
            case "auth/invalid-verification-code":
              setLoading(false);
              addToast("Nomor OTP tidak sama dengan yang dikirimkan", {
                appearance: "error",
                autoDismiss: true,
              });
              setInput((val) => ({
                ...val,
                otp: "",
              }));
              break;
            case "auth/code-expired":
              setLoading(false);
              addToast("Nomor OTP sudah expired, silahkan kirim ulang", {
                appearance: "error",
                autoDismiss: true,
              });
              break;
            default:
              setLoading(false);
              addToast("An unknown error occured.", {
                appearance: "error",
                autoDismiss: true,
              });
              break;
          }
          showLog(`Otp Register = ${error}`);
        });
    } else {
      navigate(`${router}/login`);
    }
  }

  function onSubmitOTP(e) {
    showLog("OtpRegister Masuk onSubmitOTP");
    e.preventDefault();
    onOtp();
    setLoading(true);
  }

  return (
    <ScreenOTP
      onClickBack={() => navigate(`${router}/register`)}
      input={input}
      setInput={setInput}
      onSubmitOTP={onSubmitOTP}
      loading={loading}
      ResendOTP={() => {
        {
          navigate(`${router}/register`);
        }
      }}
    />
  );
}

export default KodeOTP;
